import { Component, OnInit, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent, IsRowSelectable } from 'ag-grid-community';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { lastValueFrom, Subject } from 'rxjs';
import { Utilities } from 'src/app/models/utilities';
import { AppCoreService } from 'src/app/services/app-core.service';
import { AWBService } from 'src/app/services/operations/awb.service';
import Swal from 'sweetalert2';

enum IDeliveryModeDB {
    SPLIT = 'Split',
    CLUB = 'Club'
}
@Component({
    selector: 'app-awb-received',
    templateUrl: './awb-received.component.html',
    styleUrls: ['./awb-received.component.scss']
})

export class AwbReceivedComponent implements OnInit, AfterViewInit {
    @Output() inscanSuccess = new EventEmitter<void>();

    awbInscanForm: FormGroup;
    isFormSubmitted = false;
    selectedSCId: number;
    deliverModeData: any;
    shipmentList: any = [];
    awbList: any[] = [];
    btnMarkReceivedDisabled = true;
    rowData: any = [];
    partScan = false;
    allScan = false;

    private gridApi!: GridApi;
    private gridColumnApi!: ColumnApi;
    public context: any;
    isAllGridDataLoaded = false;
    defaultColDef = {
        sortable: true,
        resizable: false,
        filter: false,
        floatingFilter: false
    };
    gridOptions: GridOptions = {
        rowSelection: 'multiple',
        pagination: true,
        paginationPageSize: 10,
        suppressRowClickSelection: true,
        domLayout: "autoHeight"
    }
    columnDefs = [
        {
            headerName: '',
            field: 'isshipmentreceived',
            checkboxSelection: true, headerCheckboxSelection: true,
            width: 30
        },
        { headerName: 'Awb Number', field: 'awbnumber' },
        { headerName: 'Status', field: 'status' }
    ];

    constructor(
        private appCoreService: AppCoreService,
        public activeModal: NgbActiveModal,
        private ngxLoaderService: NgxUiLoaderService,
        private _fb: FormBuilder,
        private awbService: AWBService,
        private titleService: Title,
        private utilities: Utilities,
    ) {
        titleService.setTitle('Air Way Bill');
    }

    ngOnInit() {
        this.appCoreService.SelectedServiceCenter().subscribe((val) => {
            this.selectedSCId = val;
        });
        this.awbInscanForm = this._fb.group({
            txtAwbNumber: [null, Validators.required]
        });
    }

    ngAfterViewInit(): void {
        this.utilities.focusFirstElement(this.awbInscanForm);
    }

    onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        params.api.sizeColumnsToFit();
    }

    onTextChange() {
        const inputAWBNumber = this.awbInscanForm.get('txtAwbNumber')?.value;
        this.shipmentList.push(inputAWBNumber);
    }

    async onSaveClick() {
        this.isFormSubmitted = true;

        if (this.awbInscanForm.valid) {
            const reqObj = {
                awbnumber: this.awbInscanForm.get('txtAwbNumber')?.value?.trim(),
                generatedfromid: this.selectedSCId
            };
            this.checkDeliveryMode(reqObj);
        }
    }

    async openConfirmationDialog(reqObj: any) {
        const result = await Swal.fire({
            // title: 'Confirmation',
            html: '<span>This shipment seems to be a <b>misrouted</b> shipment.</span><br><span>Do you still want to receive it ?</sapn>',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            allowEscapeKey: false,
            allowOutsideClick: false
        });
        if (result.isConfirmed) {
            //if user wants to receive shipment --> two TRANSACTION_STATUS insert : SHIPMENT_MISROUTED
            reqObj.misroute = true;
            this.proceedWithAwbInscan(reqObj);
        }
    }

    proceedWithAwbInscan(reqObj: any) {
        this.awbService.AwbInscan(reqObj).subscribe((res) => {
            if (res && res.success) {
                if (res.data.misroute) {
                    this.openConfirmationDialog(reqObj);
                } else {
                    this.awbInscanForm.get('txtAwbNumber').reset();
                    this.appCoreService.showMessage('Status Updated successfully', 'Success', 'success');
                    this.isFormSubmitted = false;
                    // this.activeModal.close('Save Click');// will manually close
                    this.inscanSuccess.emit();
                }
                this.ngxLoaderService.stop();
            } else if (res && !res.success) {
                this.ngxLoaderService.stop();
                this.appCoreService.showMessage(res.message, 'Error', 'error');
            } else if (res && res?.error) {
                this.ngxLoaderService.stop();
                this.appCoreService.showMessage(res?.message || 'An error occurred', 'Warning', 'warning');
            }
        });
    }


    checkDeliveryMode(reqObj: any) {
        this.ngxLoaderService.start();
        this.awbService.CheckDeliveryMode(reqObj.awbnumber).subscribe(async (res) => {
            if (res && res.success) {
                // this.ngxLoaderService.stop();
                this.deliverModeData = res.data[0]
                res.data[0]?.deliverymode === IDeliveryModeDB.SPLIT ? await this.showDeliveryModeModal('<span>Do you want to Club this?</span>') : this.proceedWithAwbInscan(reqObj);
            } else if (res && !res.success) {
                this.ngxLoaderService.stop();
            }
        })
    }

    showDeliveryModeModal = async (msg: string) => {
        const result = await Swal.fire({
            title: 'Info',
            html: msg,
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
        });
        if (result.isConfirmed) {
            this.ngxLoaderService.start();
            try {
                this.awbService.ClubAwb({ ...this.deliverModeData, club: true }).subscribe((res) => {
                    if (res && res.success) {
                        const reqObj = {
                            awbnumber: this.awbInscanForm.get('txtAwbNumber')?.value,
                            generatedfromid: this.selectedSCId
                        };
                        this.proceedWithAwbInscan(reqObj);
                    }
                });
            } catch (err) {
                this.ngxLoaderService.stop();
            }
        }
        if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {
            this.ngxLoaderService.start();
            const reqObj = {
                awbnumber: this.awbInscanForm.get('txtAwbNumber')?.value,
                generatedfromid: this.selectedSCId
            };
            this.proceedWithAwbInscan(reqObj);
        }
    }

    async getAwbInfo() {
        this.isFormSubmitted = true;
        try {
            const awbNumber = this.awbInscanForm.get('txtAwbNumber')?.value;
            if (this.awbInscanForm.valid) {
                if (awbNumber.includes('-')) {
                    this.onSaveClick();
                } else {
                    this.awbList = await this.getAllAWBInfo(awbNumber);
                    //check if already received
                    const childAwbs = this.awbList.filter(awb => !awb.isparentawb); // Get only child AWBs

                    if (childAwbs.length > 0 && childAwbs.every(awb => awb.status === 'RECEIVED')) {
                        return this.appCoreService.showMessage('All child AWB numbers are already received.', '', 'error');
                    }

                    if (this.awbList.length > 1) {
                        // this.awbInscanForm.get('txtAwbNumber').disable();
                        this.showMultiScanConfirmDialog();
                    } else {
                        //scanning master -> directly scan it 
                        this.onSaveClick();
                        this.isFormSubmitted = true;
                        // this.ngxLoaderService.stop();
                    }
                }
            }

        } catch (e) {
            console.error(e);
            this.ngxLoaderService.stop();
        }
    }

    async getAllAWBInfo(awbNumber) {
        this.ngxLoaderService.start();
        const res = await lastValueFrom(this.awbService.GetInfo({ awbnumber: awbNumber }));
    
        if (res && res?.success) {
            this.ngxLoaderService.stop();
            
            // Filter only child AWBs (having a `parentawbnumber`) and not having status 'RECEIVED'
            const filteredData = res.data.filter(x => x.parentawbnumber && x.status !== 'RECEIVED') || [];
    
            // Sort them in ascending order based on the numerical part after "-"
            filteredData.sort((a, b) => {
                const numA = parseInt(a.awbnumber.split('-')[1], 10) || 0;
                const numB = parseInt(b.awbnumber.split('-')[1], 10) || 0;
                return numA - numB;
            });
    
            return filteredData;
        } else if (res && !res?.success) {
            this.ngxLoaderService.stop();
            return [];
        }
    }
    

    showMultiScanConfirmDialog = async () => {
        const result = await Swal.fire({
            title: 'Info',
            html: '<span>There are multiple child AWB numbers.</span><br><span>Do you want to scan them?</span>',
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Scan Partialy',
            cancelButtonText: 'Scan All',
        });
        if (result.isConfirmed) {
            this.partScan = true;
            this.allScan = true;

            this.rowData = this.awbList;
        }
        if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {

            if (this.awbInscanForm.valid) {
                const reqObj = {
                    awbnumber: this.awbInscanForm.get('txtAwbNumber')?.value,
                    generatedfromid: this.selectedSCId
                };
                // this.ngxLoaderService.start(); 
                this.checkDeliveryMode(reqObj);

            }
            //this.proceedWithAwbInscan(reqObj);
        }
    }
    public isRowSelectable: IsRowSelectable = (
        params: any,
    ) => {
        // console.log('params', params);
        return params.data.isshipmentreceived !== true;
    };


    async partialScan() {
        const selectedRows = this.gridApi.getSelectedRows();
        if (selectedRows?.length) {
            let selectedNumbers = [];
            // from selected rows filter out rows with shipmentreceived false
            for (const a of selectedRows) {
                if (!a.isshipmentreceived) {
                    selectedNumbers.push({
                        awbnumber: a.awbnumber,
                        parentawbnumber: a.parentawbnumber,
                        isparentawb: a.awbnumber === a.parentawbnumber ? true : false
                    });
                }

            }

            if (selectedNumbers.length) {
                // call update api only if there are awbnumber that are pending receive
                let requestObj = {
                    type: 'partialInscan',
                    numbers: selectedNumbers,
                    generatedfromid: this.selectedSCId
                };
                this.ngxLoaderService.start();
                this.awbService.AwbInscan(requestObj).subscribe(async res => {
                    if (res && res.success) {
                        this.appCoreService.showMessage('Status Updated successfully', 'Success', 'success');
                        // this.activeModal.close('Save Click');// will manually close
                        this.inscanSuccess.emit();
                        this.ngxLoaderService.stop();

                        // reinstate scan button
                        this.allScan = false;
                        this.partScan = false;
                        this.awbInscanForm.get('txtAwbNumber').reset();
                        this.isFormSubmitted = false;
                        this.awbList = await this.getAllAWBInfo(this.awbInscanForm.get('txtAwbNumber')?.value);
                        this.rowData = this.awbList;
                    } else if (res && !res?.success) {
                        this.appCoreService.showMessage('Error In Updating Record', 'Error', 'error');
                        this.ngxLoaderService.stop();
                    }
                });
            }

        } else {
            this.appCoreService.showMessage('No AWB selected from the list', '', 'error');
        }
    }

}
